import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

function WhatsNewSection({ isMobile }) {
  const { t } = useTranslation();

  const newsItems = t("whatsnew.news_items", { returnObjects: true }) || [];

  const staticNewsData = [
    {
      image: "/assets/icon/wage-connect.png",
      date: "1 Des 2025",
    },
    {
      image: "/assets/icon/tc-icon.png",
      date: "29 Nov 2025",
    },
  ];

  const newsUpdates = newsItems.map((item, index) => ({
    ...item,
    image: staticNewsData[index]?.image || "", // Use optional chaining for safety
    date: staticNewsData[index]?.date || "",
  }));

  if (isMobile) return null;

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      style={{
        width: "45%",
        padding: "40px 36px",
        overflow: "hidden",
        position: "relative",
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* What's New Section - Centered */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          marginTop: "-20px",
        }}
      >
        {/* News Items */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          {newsUpdates.map((news, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              style={{
                display: "flex",
                gap: "16px",
                cursor: "pointer",
                padding: "16px",
                borderRadius: "12px",
                transition: "all 0.3s ease",
                backgroundColor: "rgba(255, 255, 255, 0.7)",
                backdropFilter: "blur(10px)",
                border: "1px solid #e2e8f0",
              }}
              whileHover={{
                backgroundColor: "rgba(245, 247, 250, 0.9)",
                borderColor: "#d1d5db",
                scale: 1.02,
              }}
            >
              <img
                src={news.image}
                alt={news.title}
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "8px",
                  objectFit: "contain", // Changed to contain to prevent cropping on icons
                  flexShrink: 0,
                }}
              />
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#1976d2",
                    fontWeight: "600",
                    marginBottom: "4px",
                  }}
                >
                  {news.label}
                </div>
                <h3
                  style={{
                    fontSize: "15px",
                    fontWeight: "600",
                    color: "#1a202c",
                    marginBottom: "4px",
                    lineHeight: 1.4,
                  }}
                >
                  {news.title}
                </h3>
                <p
                  style={{
                    fontSize: "13px",
                    color: "#718096",
                    lineHeight: 1.5,
                    marginBottom: "4px",
                  }}
                >
                  {news.description}
                </p>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#a0aec0",
                  }}
                >
                  {news.date}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
}

export default WhatsNewSection;
